import { useNavigate, useParams } from 'react-router-dom';

/**
 * Hook customizado para navegação que preserva o prefixo /:state/:city quando presente
 */
export const useRouteNavigation = () => {
  const navigate = useNavigate();
  const params = useParams<{ state?: string; city?: string }>();

  const navigateWithPrefix = (path: string) => {
    // Remove barra inicial se existir
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // Se estamos em uma rota com state/city, preserva o prefixo
    if (params.state && params.city) {
      navigate(`/${params.state}/${params.city}/${cleanPath}`);
    } else {
      // Navegação normal para rotas standalone
      navigate(`/${cleanPath}`);
    }
  };

  return navigateWithPrefix;
};
